import api from "../../api/services/axiosService";
import { USER_MANAGEMENT } from "../../envConstants";
import { getMobileNumber } from "../../utils/localStorage";

const baseUrl: any = { customBaseUrl: USER_MANAGEMENT, isTShots: true };

export const fetchCategories = async function () {
  let res: any = {};
  try {
    const mobileNumber = getMobileNumber();
    res = await api.get(
      `/user/tatva/shot/speciality-list?mbl_no=${mobileNumber}`,
      baseUrl
    );
    if (res?.status === 200 && res?.data?.status === 200) {
      res = res?.data?.body;
    }
  } catch (e) {
    console.error("Error while fetching categories: ", e);
  }
  return res;
};

export const fetchTatvaShots = async function (payload: any, pagination: any) {
  let res: any = {};
  try {
    const mobileNumber = getMobileNumber();
    res = await api.post(
      `user/tatva/shot/news-list?page=${pagination?.page || 0}&size=${
        pagination?.size || 11
      }&mbl_no=${mobileNumber}`,
      payload,
      baseUrl
    );
    if (res?.status === 200 && res?.data?.status === 200) {
      res = res?.data?.body;
    }
  } catch (e) {
    console.error("Error fetchTatvaShots: ", e);
  }
  return res;
};

export const fetchUserPreferences = async function () {
  let res: any = {};
  try {
    res = await api.get(
      `user/tatva/shot/v2/save-preferences`,
      {...baseUrl, isTShots: false}
    );
    if (res?.status === 200 && res?.data?.status === 200) {
      res = res?.data?.body;
    }
  } catch (e) {
    console.error("Error fetchUserPreferences: ", e);
  }
  return res;
};

export const saveUserPreferences = async function (payload: any) {
  let res: any = {};
  try {
    res = await api.post(
      `user/tatva/shot/v2/save-preferences`,
      payload,
      {...baseUrl, isTShots: false}
    );

    if (res?.status === 200 && res?.data?.status === 200) {
      res = res?.data;
    }
  } catch (e) {
    console.error("Error saveUserPreferences: ", e);
  }
  return res;
};

export const fetchSpecialityTags = async function (specialityId: number) {
  let res: any = {};
  try {
    res = await api.get(
      `user/tatva/shot/speciality-tags?speciality_id=${specialityId}`,
      baseUrl
    );

    if (res?.status === 200 && res?.data?.status === 200) {
      res = res?.data?.body;
    }
  } catch (e) {
    console.error("Error fetchSpecialityTags: ", e);
  }
  return res;
};

export const fetchTopics = async function () {
  let res: any = {};
  try {
    res = await api.get(`user/tatva/shot/speciality-home`, baseUrl);

    if (res?.status === 200 && res?.data?.status === 200) {
      res = res?.data?.body;
    }
  } catch (e) {
    console.error("Error fetchTopics: ", e);
  }
  return res;
};

export const bookmarkNews = async function (payload: any) {
  let res: any = {};
  try {
    res = await api.post(
      `user/tatva/shot/v2/news-metadata`,
      payload,
      {...baseUrl, isTShots: false}
    );
  } catch (e) {
    console.error("Error bookmarkNews: ", e);
  }
  return res;
};

export const fetchSpecialities = async function () {
  let res: any = {};
  try {
    res = await api.post(`/master/pm-specialities`, {}, baseUrl);

    if (res?.status === 200) {
      res = res?.data;
    }
  } catch (e) {
    console.error("Error fetchSpecialities : ", e);
  }
  return res;
};

export const fetchPlanDetails = async function () {
  let res: any = {};
  try {
    res = await api.get(
      `user/tatva/shot/v2/plan-details`,
      {...baseUrl, isTShots: false}
    );
    if (res?.status === 200 && res?.data?.status === 200) {
      res = res?.data?.body;
    }
  } catch (e) {
    console.error("Error fetchPlanDetails: ", e);
  }
  return res;
};

export const fetchChatHistoryAi = async function () {
  let res: any = {};
  try {
    res = await api.get(
      `user/tatva/shot/v2/chat-history`,
      {...baseUrl, isTShots: false}
    );
    if (res?.status === 200 && res?.data?.status === 200) {
      res = res?.data?.body?.data;
    }
  } catch (e) {
    console.error("Error while fetching history: ", e);
  }
  return res;
};
